export default "__VITE_ASSET__DuyEQB8x__"